<template>
    <div class="modal-backdrop">
        <div class="card col-lg-5 col-md-8 mt-md-4 col-11 p-0">
            <div class="modal-content postmodalcontent">
                <div class="modal-header borderbottom p-4">
                    <div class="d-lg-flex d-md-flex" v-if="JobObject.type !== 'view'">
                      <h5 class="modal-title font16-bold ml-2" id="exampleModalLabel">Preview Job Post</h5><span class="tagLineReport mt-2 ml-2" >(This is how page will look like to job seekers.)</span>
                    </div>
                    <div class="d-lg-flex" v-if="JobObject.type === 'view'">
                      <h5 class="modal-title font16-bold ml-2" id="exampleModalLabel">Job Details</h5>
                    </div>   
                    <button type="button" class="close" @click="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body bodymodal11">
                    <div class="col-12 backgroundcolor1 borderbottom p-2 pb-4 d-flex">
                      <div class="col-2">
                        <img :src="companyDetails.companyLogoLink" class="img-fluid rounded-circle" alt="companylogo">
                      </div>
                      <div class="col-10 pt-2">
                        <div class="d-flex justify-content-between">
                          <span class="fontsize24 black proximanova stylebold">{{JobObject.jobTitle}}</span>
                          <img src="../../assets/sharearrow.png" width="20px" height="20px" class="mr-3 my-auto" alt="share" v-if="JobObject && JobObject.jobStatus == 'POST'" v-popover:fooNA2>
                          <popover  name="fooNA2"  class="" id="jobmenu">
                            <div class="p-1">
                                  <div class="d-flex pl-2 ml-1 pointer actionlink" @click="shareJob(JobObject)">
                                    <img src="../../assets/sharejob.png" width="20" height="20" class="my-auto" alt="edit">
                                    <span class="p-2 font14-opacity80 proximanova">Share</span>
                                  </div>
                                  <div class="d-flex pl-2 ml-1 pointer actionlink" @click="copyJobLink(JobObject)">
                                    <img src="../../assets/hyperlink1.png" width="20" height="20" class="my-auto" alt="delete">
                                    <span class="p-2 font14-opacity80 proximanova">Copy link</span>
                                  </div>
                                </div>
                              </popover>
                        </div>
                        <div class="d-flex flex-column mt-2">
                          <span class="fontsize16 black proximanova">{{companyDetails.companyName}}</span>
                          <div>
                            <span class="fontsize16 black60 proximanova">{{companyDetails.industry}}</span>
                            <span class="ml-2 mr-2 black60">|</span>
                            <span class="fontsize16 black60 proximanova">{{companyDetails.countryName}}</span>
                          </div>
                        </div>
                        <div class="d-flex mt-2 justify-content-between">
                          <div class="mt-1">
                            <!-- <span class="fontsizemd black stylebold proximanova" v-if="JobObject.type === 'view' && JobObject.creationD">{{JobObject.creationD | moment("from", "now", true)}} ago</span> -->
                            <span class="fontsizemd black stylebold proximanova" v-if="JobObject.type === 'view' && JobObject.creationD">{{JobObject.creationD | moment("MMM Do YYYY, h:mm a")}}</span>
                            <span class="ml-2 mr-2 black60" v-if="JobObject.type === 'view'">|</span>
                            <span class="forgot-password proximanova" v-if="JobObject.type === 'view'">{{JobObject.totalApplicantsCount}} Candidates Applied</span>
                          </div>
                          <div class="mr-2" v-if="JobObject.type !== 'view'">
                            <button class="btn button-cancel11 borderradius20 mr-2 navtoPage proximanova">Save</button>
                            <button class="btn sign-up-button borderradius20 blackbackhroundsignin fontsizemd proximanova">Apply</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 p-3">
                      <div class="d-flex mb-2">
                        <div class="pl-2 pr-1">
                          <img src="../../assets/JobViewHired.svg" alt="job">
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black60 proximanova">Employment Type</span>
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black proximanova">{{JobObject.selectedEmployemntTypeName}}</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="pl-2 pr-1">
                          <img src="../../assets/JobViewSeniority.svg" alt="seniority">
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black60 proximanova">Seniority</span>
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black proximanova">{{JobObject.selectedSeniorityTypeName}}</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="pl-2 pr-1">
                          <img src="../../assets/JobViewAmount.svg" alt="payscale">
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black60 proximanova">Pay Scale</span>
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black proximanova">{{JobObject.selectedPayScaleFrom}} - {{JobObject.selectedPayScaleTo}}</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="pl-2 pr-1">
                          <img src="../../assets/JobViewLocation.svg" alt="location">
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black60 proximanova">Job Location</span>
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black proximanova">{{JobObject.selectedCity.cityName}}, {{JobObject.selectedCountry.countryName}}, {{JobObject.pinCode}}</span>
                        </div>
                      </div>
                      <div class="horizontalline mt-3"></div>
                    </div>
                    <div class="col-12">
                      <div class="d-flex flex-column pl-3 pr-3 pt-2 pb-1">
                        <span class="fontsize16 stylebold proximanova black mb-2">Job Description</span>
                        <!-- <span class="fontsizemd proximanova black mb-3 lineheight22">{{JobObject.jobDescription}}</span> -->
                        <quill-editor v-model="JobObject.jobDescription" :options="editorOption" class="quill1" disabled></quill-editor>
                      </div>
                      <div class="horizontalline mt-1 mb-2"></div>
                    </div>
                    <div class="col-12">
                      <div class="d-flex flex-column pl-3 pr-3 pt-2 pb-1">
                        <span class="fontsize16 stylebold proximanova black mb-2">Skills Required</span>
                        <div class="row no-gutters mt-2 ml-0">
                            <div v-if="JobObject.addedSkillsList.length > 0" class="d-flex flex-wrap mb-3 col" >
                                <div v-for="(skill, index) in JobObject.addedSkillsList" :key="index" >
                                  <div class="pl-3 pr-3 p-1 mr-3 black60 fontsize12 backgroundcolor2 stylebold borderradius10 proximanova d-flex mt-1">
                                      {{skill.skillName}}
                                  </div>
                                </div>
                            </div>
                        </div>
                      </div>
                      <div class="horizontalline mt-3 mb-3"></div>
                    </div>
                    <div class="col-12">
                      <div class="d-flex flex-column pl-3 pr-3 pt-2 pb-1">
                        <span class="fontsize16 stylebold proximanova black mb-2">More Details</span>
                        <span class="fontsizemd proximanova black mb-2 lineheight22">Screening Questions.</span>
                        <span class="fontsizemd proximanova black60 mb-2 lineheight22">Any screening questions added will appear once you click Apply.</span>
                        <div class="row no-gutters mt-1 mb-2 ml-0">
                            <div v-if="JobObject.screeningQuestionsList.length > 0" class="d-flex flex-wrap mb-3 col" >
                                <div v-for="(qsn, index) in JobObject.screeningQuestionsList" :key="index" >
                                  <div class="pl-3 pr-3 p-1 mr-3 black60 fontsize12 backgroundcolor2 stylebold borderradius10 proximanova d-flex mt-1">
                                      {{qsn.question}}
                                  </div>
                                </div>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="horizontalline mt-1 mb-2" v-if="JobObject.type !== 'view'"></div>
                    <div class="col-12" v-if="JobObject.type !== 'view'">
                      <div class="d-flex flex-column pl-3 pr-3 pt-2 pb-3">
                        <span class="fontsize16 stylebold proximanova black mb-2">About the Company</span>
                        <div class="d-flex mt-2">
                          <div class="">
                            <img :src="companyDetails.companyLogoLink"  oncontextmenu="return false" alt="companylogo" class="profile-border img-fluid rounded-circle profileimgad" id="profImage">
                          </div>
                          <div class="d-flex flex-column col-10 mt-2">
                            <div class="d-flex justify-content-between">
                              <span class="font32 proximanova">{{companyDetails.companyName}}</span>
                              <button class="btn button-cancel11 borderradius20 mr-2 navtoPage proximanova" style="height:35px">Follow</button>
                            </div>
                            <div class="d-flex">
                              <span class="fontsize16 black60 proximanova ">{{companyDetails.industry}}</span>
                              <span class="ml-2 mr-2 black60">|</span>
                              <span class="fontsize16 black60 proximanova">{{companyDetails.countryName}}</span>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="col-2"></div>
                          <div class="col-10">
                            <span class="fontsizemd proximanova black">{{companyDetails.description}}</span>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="col-2"></div>
                            <div class="col-10">
                              <div class="row ">     
                                <div class="mt-4 count">       
                                  <div class="row m-0">       
                                    <div class="col-3 mr-3">
                                      <label class="font14bold proximanova">Followers</label>
                                      <label class="font14bold proximanova">{{followersCount}}</label>
                                    </div>
                                    <div class="col-3">
                                      <label class="font14bold proximanova">Following</label>
                                      <label class="font14bold proximanova">{{followingCount}}</label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="horizontalline mt-1 mb-2" v-if="JobObject.type !== 'view'"></div>
                    <span v-if="JobObject.type !== 'view' && savedIntroVideoLink" class="fontsize14 black stylebold proximanova ml-3">Intro Video</span>
                    <div v-if="JobObject.type !== 'view' && savedIntroVideoLink" class="mt-2">
                      <video height="320" controls oncontextmenu="return false" :src="savedIntroVideoLink" controlsList="nodownload"  id="introVideo" > </video>
                    </div>
                    <div class="col-12 mb-4" v-if="JobObject.type !== 'view'">
                      <label class="fontsize14 black stylebold proximanova ml-3">More Details</label>
                      <div class="d-flex mb-2">
                        <div class="col-3">
                          <span class="fontsizemd black60 proximanova">Contact Number</span>
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black proximanova" v-if="companyDetails.contactNumber">{{companyDetails.contactNumber}}</span>
                          <span class="fontsize14 black proximanova" v-else>--</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="col-3">
                          <span class="fontsizemd black60 proximanova">Company Size</span>
                        </div>
                        <div class="col-5">
                          <span class="fontsizemd black proximanova" v-if="companyDetails.companySize">{{companyDetails.companySize}}</span>
                          <span class="fontsize14 black proximanova" v-else>--</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="col-3">
                          <span class="fontsizemd black60 proximanova">Industry</span>
                        </div>
                        <div class="col-5">
                          <span class="fontsizemd black proximanova" v-if="companyDetails.industry">{{companyDetails.industry}}</span>
                          <span class="fontsize14 black proximanova" v-else>--</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="col-3">
                          <span class="fontsizemd black60 proximanova">Founded</span>
                        </div>
                        <div class="col-5">
                          <span class="fontsizemd black proximanova" v-if="companyDetails.founded">{{companyDetails.founded}}</span>
                          <span class="fontsize14 black proximanova" v-else>--</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="col-3">
                          <span class="fontsizemd black60 proximanova">Specialities</span>
                        </div>
                        <div class="col-5">
                          <span class="fontsizemd black proximanova" v-if="companyDetails.specialities">{{companyDetails.specialities}}</span>
                          <span class="fontsize14 black proximanova" v-else>--</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="col-3">
                          <span class="fontsizemd black60 proximanova">Type</span>
                        </div>
                        <div class="col-5">
                          <span class="fontsizemd black proximanova" v-if="companyDetails.type">{{companyDetails.type}}</span>
                          <span class="fontsize14 black proximanova" v-else>--</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="col-3">
                          <span class="fontsizemd black60 proximanova">Location</span>
                        </div>
                        <div class="col-5">
                          <span class="fontsizemd black proximanova" v-if="companyDetails.cityName">{{companyDetails.cityName}}, {{companyDetails.stateName}}, {{companyDetails.countryName}}</span>
                          <span class="fontsize14 black proximanova" v-else>--</span>
                        </div>
                      </div>
                      <div class="horizontalline mb-2 mt-3"></div>
                      <div class="d-flex">
                        <div class="mt-1 mb-1 ml-3 mr-auto">
                          <label class="fontsize14 black60 stylebold proximanova">Social Media</label>
                        </div>
                      </div>
                      <div class="mb-2">
                        <div class="col-12 pl-0 d-flex">
                          <span class="fontsize14 black60 proximanova col-lg-4 col-6">Twitter</span>
                          <a class="fontsize14 blue proximanova" v-if="companyDetails.twitterURL" :href="companyDetails.twitterURL" target="_blank">
                            <img src="../../assets/twitter.svg" class="img-fluid" alt="twitter">
                          </a>
                          <span class="fontsize14 black proximanova" v-else>--</span>
                        </div>
                      </div>
                      <div class=" mb-2">
                        <div class="col-12 pl-0 d-flex">
                          <span class="fontsize14 black60 proximanova col-lg-4 col-6">Linked in</span>
                          <a class="fontsize14 blue proximanova" v-if="companyDetails.linkedInURL" target="_blank" :href="companyDetails.linkedInURL">
                            <img src="../../assets/linkedin.svg" class="img-fluid" alt="linkedin">
                          </a>
                          <span class="fontsize14 black proximanova" v-else>--</span>
                        </div>
                      </div>
                      <div class="mb-2">
                        <div class="col-12 pl-0 d-flex">
                          <span class="fontsize14 black60 proximanova col-lg-4 col-6">Youtube</span>
                          <a class="fontsize14 blue proximanova" v-if="companyDetails.youtubeURL" target="_blank" :href="companyDetails.youtubeURL">
                            <img src="../../assets/youtube.svg" class="img-fluid" alt="youtube">
                          </a>
                          <span class="fontsize14 black proximanova" v-else>--</span>
                        </div>
                      </div>
                    </div>
                    <!-- <div class=" mb-4 introvideocard" >
                      <div class="p-3 ml-2" v-if="savedIntroVideoLink !== null">
                        <span class="fontsize14 black stylebold">Intro Video</span>
                      </div>
                      <div class="card introvideocard" v-if="savedIntroVideoLink !== null">
                        <div>
                        <video height="320" oncontextmenu="return false" :src="savedIntroVideoLink" controlsList="nodownload"  id="introVideo" > </video>
                      </div>
                      <div class="card-img-overlay ">
                        <div class="row no-gutters mb-3 ml-0 mr-0 companyvid_overlay1">
                          <div class="black_overlay_height"></div>
                        </div>
                        <div class="mt-3">
                          <img src="../../assets/play_video.svg" v-if="!playingIntroVideo" class="playpausevideobtn" alt="" @click="playIntroVideo">
                          <img src="../../assets/Pausevideo.svg" class="playpausevideobtn" v-if="playingIntroVideo" alt="" @click="playIntroVideo">
                        </div>
                        <div class="bottom">
                          <div class="companyvid_overlay2">
                            <div class="black_overlay_height"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
            </div>
        </div>
    </div>  
</template>

<script>
import httpuserprofile from "@/js/http-userprofile.js";
import httpjob from "@/js/http-postjob.js"
import commonUtils from '@/js/common-utils.js'
import sessionUtils from "@/js/session-util.js";
export default{
   data() {
    return{
      savedIntroVideoLink : null,
      followersCount : 0,
      followingCount : 0,
      companyprofileId : null,
      addedSkillsList : ['java', 'html', 'css', 'javascript'],
      businessAccountId : null,
      companyProfileId : null,
      companyDetails : {},
      editorOption: {
        theme: 'bubble'
      },
    }
  },
  props : [
        'JobObject'
    ],
  methods:{
    //copy & share job link
      copyJobLink(jobObj) {
        commonUtils.copyJobLink(jobObj)
      },
      shareJob : function(jobObj){
        commonUtils.shareJob(jobObj)
      },
    close() {
      this.$emit('closePreviewModal', "cancel" );
    },
    saveJobAsaDraft(){
      console.log("save as a draft : ", this.JobObject)
    },
    getCompanyData() {
      httpjob.get('/postjob/getcompanyProfileData?businessAccountId='+this.JobObject.employeeId)
      .then((response) => {
        this.companyDetails = response.data;
        console.log("user details : ", this.companyDetails)
      }).catch((e) => {
        console.log(e)
      })
    },
    // get employmment type data based on emploment Id
    getEmploymentTypesList(){
      httpjob.get('/postjob/getListOfIndexDetails?indexcode=2')
      .then((response) => {
        let list = response.data
        console.log(list)
        for(var i =0; i < list.length; i++){
          if(this.JobObject.type === 'view'){
            if(this.JobObject.employmentTypeId === list[i].id) {
              this.JobObject.selectedEmployemntTypeName = list[i].indexDetailName
            }
          }else{
            if(this.JobObject.selectedEmploymentType === list[i].id) {
              this.JobObject.selectedEmployemntTypeName = list[i].indexDetailName
            } 
          }
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    //fetch seniority types list
    getSeniorityList(){
      httpjob.get('/postjob/getListOfIndexDetails?indexcode=17')
      .then((response) => {
        let list = response.data
        console.log(list)
        for(var i =0; i < list.length; i++){
          if(this.JobObject.type === 'view'){
            if(this.JobObject.seniorityId === list[i].id) {
              this.JobObject.selectedSeniorityTypeName = list[i].indexDetailName
            }
          }else{
            if(this.JobObject.selecetdSeniority === list[i].id) {
              this.JobObject.selectedSeniorityTypeName = list[i].indexDetailName
            }
          }
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    //get intro video while loading the component
      getIntroVideo() {
        httpjob.get('/postjob/getCompanyVideosList?companyProfileId='+this.JobObject.companyProfileId+'&businessAccountId='+this.JobObject.employeeId+'&videoType=INTRO')
        .then((response) => {
          console.log(response)
          this.savedIntroVideoLink = response.data[0].videoLink;
        }).catch((e) => {
          console.log(e)
        })
      },
      fetchCompanyFollowCounts(){
      httpuserprofile.get("/userprofile/getCompanyFollowAndFollowingCount?companyProfileId="+this.JobObject.companyProfileId)
      .then((response) => {
        console.log("counts of the company : ", response);
        this.followersCount = response.data.followerCount;
        this.followingCount = response.data.followingCount;
      })
    },
  },
   mounted() {
    console.log("jobobejct : ", this.JobObject)
    this.businessAccountId = sessionUtils.getBusinessAccountId()
    this.companyprofileId = sessionUtils.getCompanyProfileId();
    this.getCompanyData()
    this.getIntroVideo()
    this.fetchCompanyFollowCounts()
    //get emplyemtnt type and seniority when view job details
    // if(this.JobObject.type === 'view') {
      this.getEmploymentTypesList()
      this.getSeniorityList()
    // }
  },

}

</script>

<style scoped>
.modal-backdrop {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000 !important;
}
.dropdown-position-bottom.postvideomenu {
    z-index: 3 !important;
    color: rgba(31,31,31,1)  !important;
    font-size: 12px !important;
    top: 50px !important;
    font-weight: 500;
    width: 170px !important;
    left: unset !important;
  }
  .vue-popover.dropdown-position-bottom.postvideomenu:before {
    display: none !important;
  }
  .dropdown-position-bottom.postvideomenu1{
    right: 0;
  }
.quill1{
  width: 100%;
}
#introVideo{
  width: 100%;
  background: black;
}
.card {
    padding: -5px !important;
    margin: 0 auto;
}
label input[type="radio"]:checked ~ span {
    color: #007AFF;
}
.postmodalcontent{
  border: none !important;
}
.btn:focus{
  box-shadow: none;
}
.tagLineReport{
	height: 10px;
	color: #1F1F1F;
	font-size: 10px;
	font-weight: bold;
	letter-spacing: 0;
	font-style: italic;
  opacity: 60%
}
.button-cancel11 {
  border: 1px solid #1f1f1f;
  border-radius: 4px;
  transition : ease-out 0.3s;
  font-size: 14px !important;
	position: relative;
	z-index : 1;
}
.modal-header{
  border: none;
}
.bodymodal11{
  padding: 0 !important;
  height: 80vh;
  overflow-y: auto;
  /* .row{
    margin: -15px;
  } */
}
.bodymodal11{
  background-color: white;
}
.profile-border{
  padding: 2px;
  border: 2px solid #ced4da;
  border-radius: 50%;
}
/*hide scroll bar */
.bodymodal11::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
.bodymodal11 {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
.close{
  padding: 1px 7px 5px 7px !important;
  margin-top: -3px !important;
  margin-right: 5px !important;
}
.close:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
@media screen and  (max-width : 600px){
  .card{
    margin-top: 4%;
  }
}
</style>